export default class Select {
	constructor(el) {
		this.element = el;
		this.selectGroups 	= this.element.querySelectorAll('[selectgroup]');
		this.optionValues 	= this.element.querySelectorAll('[optionvalue]');
		this.resetFields	= this.element.querySelectorAll('[selectreset]');
		this.globalResets	= document.querySelectorAll('[data-resetfilters]');

		this.selectGroups.forEach((selectGroup) => {
			selectGroup.addEventListener('click', (event) => {
				selectGroup.toggleAttribute('optionsvisible');
			});
		});

		this.resetFields.forEach((resetField) => {
			resetField.addEventListener('click', (event) => {
				this.resetField(resetField.closest('[selectgroup]'), resetField.closest('[selectgroup]').querySelectorAll('[optionvalue]'), true);
				event.stopPropagation();
			});
		});

		this.optionValues.forEach((optionValue) => {
			optionValue.addEventListener('click', (event) => {
				this.changeValue(optionValue, optionValue.parentElement.querySelectorAll('[optionvalue]'), optionValue.closest('[selectgroup]'));
			});
		});
	}
	changeValue(optionValue, selectOptions, selectGroup) {
		selectOptions.forEach((selectOption) => {
			selectOption.removeAttribute('selected');
		});

		optionValue.setAttribute('selected', '');
		selectGroup.setAttribute('optionselected', '');

		selectGroup.querySelector('[selectactive]').innerHTML = optionValue.getAttribute('optionprettyvalue');

		selectGroup.closest('[data-component="forms"]').querySelector('input[name='+selectGroup.getAttribute('selectgroup')+']').value = optionValue.getAttribute('optionvalue');
		selectGroup.closest('[data-component="forms"]').querySelector('input[name='+selectGroup.getAttribute('selectgroup')+']').setAttribute('value', optionValue.getAttribute('optionvalue'));

		document.querySelector('[mobilereset]').style.display = 'block';

		let ajaxParent = selectGroup.closest('.ajax-load-more');
		if(ajaxParent.hasAttribute('splitloadposts')) {
			let filters 			= ajaxParent.querySelector('.filter-form');
			let articlesInitial		= document.querySelector('[articlesinitial]');
			let articlesAdditional 	= document.querySelector('[articlesadditional]');
			let hideOnFilter 		= document.querySelectorAll('[hideonfilter]');
			window.app.loadPosts.loadPostsSplit('filter-change', filters, articlesInitial, articlesAdditional, hideOnFilter);
		} else {
			let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
			let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
			let loadMoreButtonWrapper 		= ajaxParent.querySelector('.load-more-button');
			let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
			let paginationContainer			= ajaxParent.querySelector('.pagination-container');

			window.app.loadPosts.loadPosts('filter-change', ajaxParent, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper);
		}
	}

	resetField(selectGroup, selectOptions, singularReset) {
		selectGroup.removeAttribute('optionselected');

		selectOptions.forEach((selectOption) => {
			selectOption.removeAttribute('selected');
		});

		selectGroup.querySelector('[selectactive]').innerHTML = selectOptions[0].getAttribute('optionprettyvalue');
		selectOptions[0].setAttribute('selected', '');

		selectGroup.closest('[data-component="forms"]').querySelector('input[name='+selectGroup.getAttribute('selectgroup')+']').value = '';
		selectGroup.closest('[data-component="forms"]').querySelector('input[name='+selectGroup.getAttribute('selectgroup')+']').setAttribute('value', '');

		if(singularReset) {
			let ajaxParent = selectGroup.closest('.ajax-load-more');
			if(ajaxParent.hasAttribute('splitloadposts')) {
				let filters 			= ajaxParent.querySelector('.filter-form');
				let articlesInitial		= document.querySelector('[articlesinitial]');
				let articlesAdditional 	= document.querySelector('[articlesadditional]');
				let hideOnFilter 		= document.querySelectorAll('[hideonfilter]');
				window.app.loadPosts.loadPostsSplit('filter-change', filters, articlesInitial, articlesAdditional, hideOnFilter);
			} else {
				let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
				let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
				let loadMoreButtonWrapper 		= ajaxParent.querySelector('.load-more-button');
				let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
				let paginationContainer			= ajaxParent.querySelector('.pagination-container');

				window.app.loadPosts.loadPosts('filter-change', ajaxParent, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper);
			}
		}
	}
}
